export const ACCOUNT_OVERVIEW_LABEL = 'account.accountOverview';
export const lblOverviewOrderHeading = 'lbl_overview_ordersHeading';
export const lblOrdersTileHeading = 'lbl_ordersTile_heading';
export const lblViewAllOrders = 'lbl_ordersTile_viewAllOrders';
export const lblNoOrderYet = 'lbl_ordersTile_noOrderYet';

export const OrderTileLabels = {
  account: {
    accountOverview: {
      [lblOverviewOrderHeading]: 'Orders',
    },
  },
};

export const OrdersTileLabels = {
  account: {
    orders: {
      [lblOrdersTileHeading]: 'My Recent Orders',
      [lblViewAllOrders]: 'View All Orders',
      [lblNoOrderYet]: 'You have not placed any orders yet.',
    },
  },
};
